
      const params = new URLSearchParams(window.location.search);
      const version = params.get("v");
      const source =
        import.meta.env.MODE === "development"
          ? "/src/main.tsx"
          : version
            ? new URL(`./plugin.js?v=${encodeURIComponent(version)}`, window.location.href).toString()
            : new URL("./plugin.js", window.location.href).toString();

      void (async () => {
        await import(source);
      })();
    